var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('section-con',{attrs:{"main":"提升机构教学质量","sub":"让机构老师专注于上课，扩大带班量"}},[_c('img',{staticClass:"content-qua",attrs:{"src":"https://ms-public.oss-cn-zhangjiakou.aliyuncs.com/cactus-official/phone/images/production/content-6.png"}})])}
var staticRenderFns = []

export { render, staticRenderFns }